import { render, staticRenderFns } from "./flights.vue?vue&type=template&id=adb4fcec&"
import script from "./flights.vue?vue&type=script&lang=js&"
export * from "./flights.vue?vue&type=script&lang=js&"
import style0 from "./flights.vue?vue&type=style&index=0&id=adb4fcec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports